export const onlyDigits = (value: unknown): string => String(value ?? "").replace(/\D/g, "");

export function formatCpf(digits: string): string {
  let out = "";
  digits.slice(0, 11).split("").forEach((c, i) => {
    if (i === 3 || i === 6) out += ".";
    if (i === 9) out += "-";
    out += c;
  });
  return out;
}

export function isValidCpf(value: string): boolean {
  const d = onlyDigits(value);
  if (d.length !== 11 || /^(\d)\1{10}$/.test(d)) return false;
  const check = (n: number) => {
    let sum = 0;
    for (let i = 0; i < n; i += 1) sum += Number(d[i]) * (n + 1 - i);
    const rest = (sum * 10) % 11;
    return rest === 10 ? 0 : rest;
  };
  return check(9) === Number(d[9]) && check(10) === Number(d[10]);
}

// Mesmas regras de Step3.js:82-93 (Q10: validação de negócio não muda).
export const isValidEmail = (value: string): boolean => /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/.test(value);
export const isValidFullName = (value: string): boolean => value !== "" && String(value).split(" ").length >= 2;

export type MaskedChangeInput = { raw: string; caret: number | null; prevDigits: string; format: (digits: string) => string; max?: number; inputType?: string };

export function nextMaskedValue({ raw, caret, prevDigits, format, max, inputType }: MaskedChangeInput): { digits: string; caret: number } {
  const at = caret == null ? raw.length : caret;
  let digits = onlyDigits(raw);
  if (max) digits = digits.slice(0, max);
  let before = onlyDigits(raw.slice(0, at)).length;
  // Apagou só a pontuação: apaga também o dígito vizinho (senão o separador volta e o campo "trava").
  if (digits === prevDigits && raw.length < format(prevDigits).length) {
    if (inputType === "deleteContentForward") digits = digits.slice(0, before) + digits.slice(before + 1);
    else if (before > 0) {
      digits = digits.slice(0, before - 1) + digits.slice(before);
      before -= 1;
    }
  }
  const out = format(digits);
  let pos = 0;
  let seen = 0;
  while (pos < out.length && seen < before) {
    if (/\d/.test(out[pos])) seen += 1;
    pos += 1;
  }
  return { digits, caret: pos };
}
